module.exports = __webpack_public_path__ + "media/photography/photographyFullService2-6a4021de.png";